import React from 'react';
import { EmailShareFragment } from '../../generated/types/EmailShareFragment';
import { EmailShareVariantFragment } from '../../generated/types/EmailShareVariantFragment';
import { ModalOverlay } from '../Modal';
import { EmailShare } from './EmailShare';

interface Props {
  variant: EmailShareFragment;
  activeVariant: EmailShareVariantFragment;
  onClose: () => void;
  show: boolean;
}

export const EmailProductShareModal: React.FC<Props> = ({
  variant,
  activeVariant,
  onClose,
  show
}) => (
  <ModalOverlay onClose={onClose} show={show}>
    <EmailShare variant={variant} activeVariant={activeVariant} onClose={onClose} />
  </ModalOverlay>
);
